// extracted by mini-css-extract-plugin
module.exports = {"full_page_loader":"LoginSpinner_full_page_loader__YMaXF","container_loader":"LoginSpinner_container_loader__zg6m1"};